var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['backbone', 'core', 'mixin', 'app-common/component/api-call', 'template/document-entry/document-request.htm', 'lib/moment', 'app-common/component/confirm-dialog', 'app-common/component/notification'], function(Backbone, core, mixin, apiCall, documentRequestTemplate, moment, confirmDialog, NotificationSupport) {
  var DocumentRequestView;
  return DocumentRequestView = (function(_super) {

    __extends(DocumentRequestView, _super);

    function DocumentRequestView() {
      DocumentRequestView.__super__.constructor.apply(this, arguments);
    }

    DocumentRequestView.prototype.className = 'document-request-wrapper';

    DocumentRequestView.prototype.notificationSelector = function() {
      return '.widget .notification-area';
    };

    DocumentRequestView.prototype.template = documentRequestTemplate;

    DocumentRequestView.prototype.documentRequestModel = null;

    DocumentRequestView.prototype.documentRequest = null;

    DocumentRequestView.prototype.events = {
      'click #document-request-accept': 'acceptRequest',
      'click #document-request-reject': 'showNewRequestForm',
      'click #document-request-cancel-new-request': 'hideNewRequestForm',
      'click #document-request-new-request': 'rejectRequest'
    };

    DocumentRequestView.prototype.initialize = function(options) {
      this.model.on('change:documentType', this.updateType, this);
      return this.loadDocumentRequest(options.documentRequestModel);
    };

    DocumentRequestView.prototype.loadDocumentRequest = function(documentRequestModel) {
      var documentId, promise,
        _this = this;
      if (documentRequestModel) {
        this.documentRequestModel = documentRequestModel;
        this.documentRequest = this.extendRequest(documentRequestModel.toJSON());
        this.render();
      } else {

      }
      documentId = this.model.get('financialDocumentId');
      if (documentId == null) {
        return;
      }
      promise = apiCall('documentrequest', 'document/' + documentId + '/request');
      return promise.success(function(res) {
        if (res) {
          _this.documentRequest = _this.extendRequest(res);
        }
        return _this.render();
      });
    };

    DocumentRequestView.prototype.remove = function() {
      DocumentRequestView.__super__.remove.apply(this, arguments);
      return this.documentRequest = null;
    };

    DocumentRequestView.prototype.render = function() {
      var options;
      options = {
        documentRequest: this.documentRequest
      };
      this.updateType();
      return this.$el.html(_.template(this.template, options));
    };

    DocumentRequestView.prototype.updateType = function() {
      var isAddonType, modelType, _ref, _ref1;
      modelType = this.model.get('documentType');
      if (!this.documentRequest) {
        return this.hideComponent();
      }
      isAddonType = modelType === 'EXPENSE_REPORT' || modelType === 'PAYROLL_REPORT' || modelType === 'MERCHANT_REPORT' || modelType === 'LOAN_INTEREST_REPORT';
      if (modelType === this.documentRequest.documentType || (isAddonType && ((_ref = this.documentRequest.documentType) !== 'RECEIPT' && _ref !== 'TRANSACTIONAL' && _ref !== 'STATEMENT' && _ref !== 'TAX' && _ref !== 'EXPORTS' && _ref !== 'INVOICE' && _ref !== 'CHECK' && _ref !== 'INTERNAL')) || (modelType === 'OTHER' && ((_ref1 = this.documentRequest.documentType) !== 'RECEIPT' && _ref1 !== 'TRANSACTIONAL' && _ref1 !== 'STATEMENT' && _ref1 !== 'TAX' && _ref1 !== 'EXPORTS' && _ref1 !== 'PAYROLL_REPORT' && _ref1 !== 'EXPENSE_REPORT' && _ref1 !== 'MERCHANT_REPORT' && _ref1 !== 'LOAN_INTEREST_REPORT' && _ref1 !== 'INTERNAL'))) {
        return this.showComponent();
      }
      return this.hideComponent();
    };

    DocumentRequestView.prototype.showComponent = function() {
      return this.$el.show();
    };

    DocumentRequestView.prototype.hideComponent = function() {
      return this.$el.hide();
    };

    DocumentRequestView.prototype.showNewRequestForm = function() {
      $('#document-request-info').hide();
      return $('#document-request-request-new').show();
    };

    DocumentRequestView.prototype.hideNewRequestForm = function() {
      $('#document-request-info').show();
      return $('#document-request-request-new').hide();
    };

    DocumentRequestView.prototype.acceptRequest = function() {
      if (this.documentRequestModel) {
        return this.documentRequestModel.trigger('accepted', this.documentRequestModel);
      }
    };

    DocumentRequestView.prototype.rejectRequest = function() {
      var notesForClient, promise, rejectParams,
        _this = this;
      $('#document-request-new-request').prop('disabled', true);
      notesForClient = $('#document-request-note-for-client').val().trim();
      rejectParams = {
        documentId: this.documentRequest.linkedDocumentId,
        noteForClient: notesForClient ? notesForClient : null
      };
      Object.keys(rejectParams).forEach(function(k) {
        return rejectParams[k] === null && delete rejectParams[k];
      });
      promise = apiCall('documentrequest', 'request/' + this.documentRequest.id + '/reject?' + $.param(rejectParams), 'put');
      promise.success(function() {
        _this.showNotification({
          type: 'success',
          text: 'Document request rejected'
        });
        _this.documentRequestModel.trigger('destroy', _this.documentRequestModel);
        return _this.hideComponent();
      });
      return promise.fail(function() {
        _this.showNotification({
          type: 'error',
          text: 'Failed to reject document request'
        });
        return $('#document-request-new-request').prop('disabled', false);
      });
    };

    DocumentRequestView.prototype.extendRequest = function(documentObj) {
      return _.extend({
        displayName: documentObj.ledgerAccountName || documentObj.addOnName,
        displayDate: moment(documentObj.date).format('MM/YYYY'),
        displayUploadDate: moment(documentObj.linkedDocumentCreationDate).format('YYYY-MM-DD')
      }, documentObj);
    };

    return DocumentRequestView;

  })(mixin.of(Backbone.View, NotificationSupport));
});
